/**
 * MiniMiser.WebApi
 * A web API for client access to patient records.   Build date: 2/19/2019 6:49:21 PM
 *
 * OpenAPI spec version: v1.0.02.19
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ClientInsEditRequestModel } from './clientInsuranceEditRequestModel';
import { CoordinationInformationModel } from './coordinationInformationModel';
import { GuardianInformationModel } from './guardianInformationModel';
import { MedicalSafetyProtocolInformationModel } from './medicalSafetyProtocolInformationModel';
import { PatientInsuranceModel } from './patientInsuranceModel';
import { StateCustodyModel } from './stateCustodyModel';


export interface PatientIntakeDocumentionModel {
  firstName?: string;
  lastName?: string;
  preferredName?: string;
  primaryPhoneNumber?: string;
  secondaryPhoneNumber?: string;
  workPhoneNumber?: string;
  /**
   * Permission to leave voicemail
   */
  voiceMailPermission?: boolean;
  address?: string;
  address2?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  birthdate?: Date;
  gender?: string;
  preferredPronouns?:string;
  primaryLanguage?: string;
  placeOfEmployment?: string;
  treatmentContactEmail?: string;
  invoicingEmail?: string;
  /**
   * Permission to send emails
   */
  hasContactLimitations?: boolean;
  contactLimitations?: string;
  emailPermission?: boolean;
  smsPermission?: boolean;
  smsAppointmentReminder?: boolean;
  
  socialSecurityNumber?: string;
  ethnicity?: string;
  citizenship?: string;
  /**
   * Currently enrolled in school or an education program?
   */
  currentlyEnrolledInAProgram?: boolean;
  highestEducationLevel?: string;
  /**
   * How did you hear about us?/Referred by:
   */
  referredBy?: string;
  /**
   * Referring Provider
   */
  referredByName?: string;
  /**
   * Referring Provider Contact Number
   */
  referredByPhoneNumber?: string;
  emergencyContactFirstName?: string;
  emergencyContactLastName?: string;
  emergencyContactPhoneNumber?: string;
  emergencyContactRelationshipToPatient?: string;
  maritalStatus?: string;
  spouseFullName?: string;
  veteranStatus?: string;
  parentsDivorced?: boolean;
  legalRight?: boolean;
  patientInsurances?: Array<PatientInsuranceModel>;
  newInsurances?: Array<ClientInsEditRequestModel>;
  insuranceEdit?: ClientInsEditRequestModel;

  isPrivatePay?: boolean;
  authorizedContactNames?: string;
  isGuardianLogin?: boolean;
  guardian?: GuardianInformationModel;
  stateCustody?: StateCustodyModel;
  isInStateCustody?: boolean;

  primaryCarePhysicianName?: string;
  primaryCarePhysicianPhoneNumber?: string;
  immunizationsUpToDate?: boolean;
  waveImmunizationsRecord?: boolean;
  schoolTreatmentCoordination?: CoordinationInformationModel;
  otherAgencyTreatmentCoordination?: CoordinationInformationModel;
  treatmentCoordinationNotes?: string;
  treatmentCoordinationInfosDisclosed?: string;
  medicalSafetyProtocol?: MedicalSafetyProtocolInformationModel;
  permissionToTransportChild?: boolean;
  permissionForPhotoAndMediaRecording?: boolean;
  PermissionForSpecialEventMediaRecording?: boolean;
  permissionForUseInPublications?: boolean;
  legalRightFileName?: string;
  legalRightFileID?: number;
  immunizationsRecordFileName?: string;
  immunizationsRecordFileID?: number;
  reasonForInquiry?: string;
  hasFormalDiagnosis?: boolean;
  diagnosis?: string;
  diagnosisLocation?: string;
  whoDiagnosed?: string;
  hasPreviousServices?: boolean;
  whatPreviousService?: string;
  previousServicesLocation?: string;
  // authorizationCategoryRequested?: number[];
  insuranceReviewPending?: boolean;
  hasRequestAccepted?: boolean;

  hasEAP?: boolean;
  eap_ID?: number;
  eapMemberId?: string;
  eapNumberOfSessions?: number;
  eapStartDate?: Date;
  eapEndDate?: Date;
}
